const protocol = window.location.protocol;
const wsProtocol = protocol === "https:" ? "wss:" : "ws:";

const serverUrl =
  process.env.NODE_ENV === "development"
    ? `${protocol}//${window.location.hostname}:${process.env.REACT_APP_SERVER_PORT}`
    : `${protocol}//${window.location.hostname}`;

const wsUrl =
  process.env.NODE_ENV === "development"
    ? `${wsProtocol}//${window.location.hostname}:${process.env.REACT_APP_SERVER_PORT}`
    : `${wsProtocol}//${window.location.hostname}`;

export const BACKEND_SERVER_URL = serverUrl;
export const BACKEND_WEBSOCKET_URL = wsUrl;
